import { useTranslation } from "react-i18next";
import { useVehiclesSocketStore } from "../../../../store/admin/vehiclesSocketStore";
import { useFilteredSocketVehicles } from "../../../../store/admin/vehiclesSocketSelector";

interface Props {
  isDarkMode: boolean;
}

// Buscador de unidades dentro del panel, justo encima de la lista que filtra.
// Antes vivía en el encabezado, a 500 px de la lista: se escribía arriba y el
// resultado aparecía en otro lado. Es el mismo estado del store, así que la
// tabla y el mapa siguen filtrando igual.
export default function UnitSearch({ isDarkMode }: Props) {
  const { t } = useTranslation("common");
  const query = useVehiclesSocketStore((s) => s.searchQuery);
  const setQuery = useVehiclesSocketStore((s) => s.setSearchQuery);
  const clear = useVehiclesSocketStore((s) => s.clearSearch);
  const total = useVehiclesSocketStore((s) => s.vehicles.length);
  const shown = useFilteredSocketVehicles().length;

  return (
    <div className="relative">
      <i
        aria-hidden
        className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}
      />
      <input
        type="search"
        value={query || ""}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => e.key === "Escape" && clear()}
        placeholder={t("header.searchPlaceholder")}
        aria-label={t("header.searchPlaceholder")}
        className={`w-full h-10 pl-9 pr-20 rounded-lg border text-sm outline-none transition-colors focus:border-primary-500 [&::-webkit-search-cancel-button]:appearance-none ${
          isDarkMode
            ? "bg-dark-card border-dark-border text-white placeholder-gray-500"
            : "bg-white border-gray-200 text-gray-900 placeholder-gray-400"
        }`}
      />
      <span className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {query && (
          <button
            type="button"
            onClick={clear}
            aria-label={t("header.clearSearch", "Borrar búsqueda")}
            className={`w-6 h-6 flex items-center justify-center rounded-md ${
              isDarkMode ? "text-gray-400 hover:text-white" : "text-gray-500 hover:text-gray-900"
            }`}
          >
            <i className="ri-close-line text-sm" aria-hidden />
          </button>
        )}
        <span className={`text-xs tabular-nums ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
          {shown}/{total}
        </span>
      </span>
    </div>
  );
}
